import React, { useState } from 'react';
import ACHEntry from './ACH/ACHEntry';
import { CCIframe  } from './CC/CCIframe'
import { CircularProgress } from '@mui/material';

export function WalletAdd({ account, itemAdded, methodMode, success, fail, tokenCreateError }) {
    const [loading, setLoading] = useState<boolean>(false)

    const completeCC = (token) => {
        success("Successfully added Credit Card")
        itemAdded()
        setLoading(true)
    }

    const completeAch = (form) => {
        success("Successfully added Bank Account")
        itemAdded()
        setLoading(true)
    }

    return (loading ? <div className='loading-container'><CircularProgress className='center-spinner' color="primary" aria-label="Loading" /></div> :
        <div>
            {methodMode === "CC" ?
                <>
                    <div className="text-left">
                        <CCIframe
                            accountId={account.id}
                            onComplete={completeCC}
                            fail={fail}
                            useAnon={false}
                            saveToWallet={true}
                            tokenCreateError={() => {
                                tokenCreateError()
                            }}
                            setPaymentMethod={() => tokenCreateError()}>
                            <div className='loading-container'><CircularProgress className='center-spinner' color="primary" aria-label="Loading" /></div>
                            <p />
                        </CCIframe>
                    </div>
                </> : methodMode === "ACH" &&
                <ACHEntry
                    accountId={account.id}
                    onComplete={completeAch}
                    fail={fail}
                    useAnon={false}
                    saveToWallet={true}
                    tokenCreateError={() => {
                        tokenCreateError()
                    }}
                    setPaymentMethod={() => tokenCreateError()}>
                    <div className='loading-container'><CircularProgress className='center-spinner' color="primary" aria-label="Loading" /></div>
                </ACHEntry>
            }
        </div>
    )
}